import Api from "@/services/api";

export const API = new Api();